import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { getUtilities } from '../api';

function UserDashboard() {
  const [utilities, setUtilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    fetchUtilities();
  }, []);

  const fetchUtilities = async () => {
    try {
      const response = await getUtilities();
      setUtilities(response.data);
    } catch (error) {
      console.error('Error fetching utilities:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUtilityClick = (utilityId) => {
    navigate(`/dashboard/utility/${utilityId}`);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const getUtilityColor = (name) => {
    switch (name) {
      case 'Cold Water':
        return 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)';
      case 'Chilled Water':
        return 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)';
      case 'Electric':
        return 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)';
      default:
        return 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)';
    }
  };

  const getUtilityIcon = (name) => {
    switch (name) {
      case 'Cold Water':
        return '💧';
      case 'Chilled Water':
        return '❄️';
      case 'Electric':
        return '⚡';
      default:
        return '📊';
    }
  };

  if (loading) {
    return <div className="loading">Loading utilities...</div>;
  }

  return (
    <div>
      <div className="navbar">
        <h1>MeterBill Pro</h1>
        <div className="navbar-right">
          <span className="navbar-user">👤 {user?.username}</span>
          <button onClick={handleLogout}>Logout</button>
        </div>
      </div>
      <div className="container">
        <div className="page-header">
          <h2>Welcome back, {user?.username}! 👋</h2>
          <p>Select a utility to manage meter readings</p>
        </div>

        <div className="grid">
          {utilities.map((utility) => (
            <div
              key={utility.id}
              className="utility-card"
              style={{ background: getUtilityColor(utility.name) }}
              onClick={() => handleUtilityClick(utility.id)}
            >
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                {getUtilityIcon(utility.name)}
              </div>
              <h3>{utility.name}</h3>
              <p>Click to view outlets and submit readings →</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default UserDashboard;
